import { colors } from '@/styles';

export const getStagingVerificationMarker = (route) => {
    const verification = route?.staging_verification;
    if (verification?.status === 'COMPLETED') {
        return {
            verified: true,
            label: 'Staging Verified',
            color: colors.greens.primary,
            verifiedBy: verification.verified_by_user?.username || null,
            completedAt: verification.completed_at || null,
        };
    }
    if (route?.needs_verification) {
        return {
            verified: false,
            label: 'Staging Verification Pending',
            color: colors.greys.primary,
            verifiedBy: null,
            completedAt: null,
        };
    }
    return null;
};
